import { createSelector } from '@ngrx/store'
import { AppState } from '../storage.module'
import { StageState } from './stage.state'

export const selectStage = (state: AppState) => state.stage

export const getUser = createSelector(selectStage, (state: StageState) => state.user)

export const getProject = createSelector(selectStage, (state: StageState) => (state.project ? state.project[0] : state.project))

export const getPartnerRoles = createSelector(selectStage, (state: StageState) => state.partnerRoles)

